/**
 * Enum for Module IDs
 * @readonly
 * @enum {name: {value: number}}
 */

export const ModuleIdEnum = Object.freeze({
  employeeProfile: 1,
  attendanceManagement: 21,
  attendanceReport: 32,
  attendanceManagementAdd: 48,
  attendanceManagementUpload: 49,
  announcements: 57,
  notificationEngine: 58,
  projectTaggingMaintenance: 59,
  projectTaggingApplication: 60,
  jobRequestModule: 61,
  bulkUtility: 62,
  attendanceLogs: 200,
  instacashCashAdvance:320,
  instcashPayments:123,
  instawagePayments:321
});
